const { isNode } = require('browser-or-node');
const publicPath = process.env.BASE_URL;

function getTemplateParameters (compilation) {
  // Discover dynamically loaded CSS path to use when JavaScript is disabled
  // Unfortunately, this doesn't work with HMR since CSS isn't listed in the chunk
  const preloadWarningCssPath = compilation
    .namedChunks.get('preload-warning')
    .files.filter(f => f.match(/preload-warning.*\.css/))[0];
  return { preloadWarningCssPath };
}

let transpileDependencies;
if (isNode) {
  // Reason: `eval` is used to prevent the lib from getting included in the production
  // package by webpack. Not sure why this happens or if there is a better way.
  // https://stackoverflow.com/a/41063795/1409101
  // eslint-disable-next-line no-eval
  const { checkModules } = eval('require')('are-you-es5');
  const excludeModules = new Set([
    // Node chokes on these since they're so big but it doesn't
    // look like we need to transpile them anyway
    '@zxcvbn-ts/language-common',
    '@zxcvbn-ts/language-en'
  ]);
  transpileDependencies = checkModules({
    path: '',
    checkAllNodeModules: false,
    ignoreBabelAndWebpackPackages: true
  }).es6Modules.filter(name => !excludeModules.has(name));
}

module.exports = {
  publicPath,

  devServer: {
    host: process.env.DEV_SERVER_HOST,
    port: parseInt(process.env.DEV_SERVER_PORT, 10),

    client: {
      webSocketURL: `auto://0.0.0.0:0${publicPath}ws`
    },

    webSocketServer: {
      options: {
        path: `${publicPath}ws`
      }
    }
  },

  transpileDependencies,

  css: {
    loaderOptions: {
      sass: {
        sassOptions: {
          quietDeps: true
        }
      }
    }
  },

  chainWebpack: config => {
    // preload.js determines if/when to load Vue
    config.entryPoints.delete('app');
    config
      .entry('preload')
      .add('./src/preload.js')
      .end();

    // Control prefetch manually to reduce network traffic
    config.plugins.delete('preload');
    config.plugins.delete('prefetch');

    if (process.env.NODE_ENV !== 'test') {
      config.optimization.splitChunks({
        cacheGroups: {
          // Chunk per vendor to reduce network traffic on vendor updates
          // Adapted from https://medium.com/hackernoon/the-100-correct-way-to-split-your-chunks-with-webpack-f8a9df5b7758#8c42
          vendor: {
            test: /[\\/]node_modules[\\/]/,
            name (module) {
              var match = module.context.match(
                /[\\/]node_modules[\\/].pnpm[\\/]((@.*?[\\/].*?)|(.*?))([\\/]|$)/);
              if (!match) {
                return;
              }

              // Get the package name (e.g. node_modules/packageName/not/this/part.js)
              const packageName = match[1];

              // NPM package names are URL-safe, but some servers don't like @ symbols
              const packageNameSafe = packageName
                .replaceAll('@', '')
                .replaceAll('/', '.')
                .replaceAll('\\', '.')
                .replaceAll('+', '_');

              return `vendor.${packageNameSafe}`;
            }
          }
        }
      });
    }

    config
      .plugin('html')
      .tap(args => {
        const options = args[0];

        // Add custom template parameters to avoid too much logic in the view
        const templateParameters = options.templateParameters;
        options.templateParameters = function (compilation, assets, assetTags, options) {
          const defaultParameters = templateParameters(compilation, assets, assetTags, options);
          return Object.assign(defaultParameters, getTemplateParameters(compilation));
        };

        return args;
      });

    // Add i18n block for single file components
    config.module
      .rule('i18n')
      .resourceQuery(/blockType=i18n/)
      .type('javascript/auto')
      .use('i18n')
      .loader('@intlify/vue-i18n-loader')
      .end();
  },

  pluginOptions: {
    i18n: {
      locale: 'en',
      fallbackLocale: 'en',
      localeDir: 'locales',
      enableLegacy: false
    }
  }
};

if (isNode) {
  module.exports.configureWebpack = {
    infrastructureLogging: {
      // VueCliMiddleware logs stderr as errors but it's very spammy since stderr
      // is the default stream for logging in Webpack
      stream: process.stdout
    }
  };
}
